export default __webpack_public_path__ + "static/media/back-arrow.8d875760.svg";